import { Guid } from "./guid";
import mapping from './mapping.js' //映射到新的请求地址


import Vue from 'vue';
const vm = new Vue();

const buildConfig = require("../build/" +
  (process.env.BUILD_ENV || "dev") +
  ".js");

const Http = function (identity) {
  this.identity = identity;
  this.tokenKey = identity + "Token";
  this.schoolKey = identity + "School";
  let DeviceID = localStorage.DeviceID;
  if (!DeviceID) {
    DeviceID = Guid.NewGuid().ToString("D");
    localStorage.DeviceID = DeviceID;
  }
  this.DeviceID = DeviceID;
  this.baseUrl = buildConfig.BASE_URL;
};

/**
 * fetch请求
 * @param {String} url 接口地址
 * @param {String} method http方法
 * @param {Object} params 请求参数
 * @param {Boolean|Object} httpConfig 配置1、布尔类型：接口是否有权限控制，默认false 2、对象类型：isAuthRequest:接口是否有权限控制，默认false；showLoading：是否显示loading效果，默认true
 * @returns {Object}
 */
Http.prototype.fetch = function (
  url,
  method,
  params = {},
  httpConfig = {},
  token,
) {
    // 处理地址映射


  let isAuthRequest = httpConfig.isAuthRequest;
  let showLoading = httpConfig.showLoading;
  // if (!httpConfig.fullUrl) {
  //   url = this.baseUrl + url;
  // }
  url = mapping(url,buildConfig)

  if (this.beforeRequest) {
    if (!this.beforeRequest(isAuthRequest, showLoading)) {
      return new Promise(() => {});
    }
  }
  let config = {
    method: method,
    mode: "cors",
  };
  config.headers = {
    DeviceType: "PC",
    DeviceID: this.DeviceID,
  };
  // if (this.identity == "student") {
  //   config.headers.SchoolID =
  //     httpConfig.school_id || localStorage[this.schoolKey] || 0;
  // }
  config.headers.SchoolID =
    httpConfig.school_id || localStorage[this.schoolKey] || 0;
  if (params instanceof FormData) {
    config.body = params;
  } else {
    if (method == "get" || method == "head") {
      if (url.indexOf("?") > 0) {
        url += "&";
      } else {
        url += "?";
      }
      for (let key in params) {
        let value = params[key];
        if (typeof value == "function" || value === undefined || value === "") {
          continue;
        }
        url += key + "=" + params[key] + "&";
      }
    } else {
      config.body = JSON.stringify(params);
    }
    config.headers["Content-Type"] = "application/json";
  }
  if (localStorage[this.tokenKey] || token) {
    config.headers.Authorization =
      "Bearer " + (token ? token : localStorage[this.tokenKey]);
  }
  return new Promise((resolve, reject) => {
    fetch(url, config).then(async res => {
      if (this.afterRequest) {
        this.afterRequest();
      }

      if (res.status == 200) {
        let data = await res.json();
        //if (data.code == 200 ||(data.code == 205 &&(data.data.need_collect_data ||url.indexOf("/api/app/user/collect") >= 0))) 
        if (data.code == 200 ||(data.code == 205 &&(url.indexOf("/api/app/user/collect") >= 0))) 
        {
          resolve(data.data || data);
        } else if (data.code == 203) {
          resolve(data);
        } else if (data.code == 4004) {
          window.location.href = buildConfig.BASE_URL + "/404.html";
        } else if (data.code == 401||data.code == 202) {
          //window.location.href =  "/pc/login";

          vm.$store.commit("logout");
          // localStorage.setItem('studentToken',111)
          vm.$message.error(data.msg);
          vm.$LoginModal.login({ type: "passwordLogin", store: vm.$store });
          reject(null);

        }else if (data.code == 205) {
          resolve(data.data || data);
          if (this.onApiError) {
            if (httpConfig.inject) {
              Object.assign(data, httpConfig.inject);
            }
            this.onApiError(data);
          }
        } else if (httpConfig.onError) {
          httpConfig.onError(data);
        } else if (this.onApiError) {
          if (httpConfig.inject) {
            Object.assign(data, httpConfig.inject);
          }
          this.onApiError(data);
          if (httpConfig.retError) {
            resolve(null);
          }
        }
        if (httpConfig.allowReject) {
          reject(data.msg);
        }

        if(data.code == 201 && url.indexOf("/api/app/login") ){
          reject(null)
        }

      } else {
        reject(res.statusText);
      }
    });
  });
};

function buildHttpConfig(isAuthRequest) {
  let config;
  if (typeof isAuthRequest == "boolean") {
    config = {
      isAuthRequest,
    };
  } else {
    config = isAuthRequest;
  }
  if (config.showLoading === undefined) {
    config.showLoading = true;
  }
  return config;
}

Http.prototype.get = function (url, params, isAuthRequest = false, token) {
  return this.fetch(url, "get", params, buildHttpConfig(isAuthRequest), token);
};

Http.prototype.post = function (url, params, isAuthRequest = false, token) {
  return this.fetch(url, "post", params, buildHttpConfig(isAuthRequest), token);
};

Http.prototype.put = function (url, params, isAuthRequest = false) {
  return this.fetch(url, "put", params, buildHttpConfig(isAuthRequest));
};

Http.prototype.delete = function (url, params, isAuthRequest = false) {
  return this.fetch(url, "delete", params, buildHttpConfig(isAuthRequest));
};

export default {
  build: (tokenKey, schoolKey) => {
    return new Http(tokenKey, schoolKey);
  },
};
